import { Component, computed, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription, take } from 'rxjs';
import { selectDataByKey } from 'src/storage/general.selectors';
import { CardDataService } from 'src/app/sarlaft/services/card-data.service';

// Path absoluto porque las rutas del NewFlowModule se registran con el prefijo completo.
const RESUMEN_COMPRA_P2P_URL = '/seguros/hogar/arriendo/cotizador/resumen-compra-p2p';

@Component({
  selector: 'app-pago-rechazado-p2p',
  templateUrl: './pago-rechazado-p2p.component.html',
  styleUrl: './pago-rechazado-p2p.component.scss',
})
export class PagoRechazadoP2PComponent implements OnInit, OnDestroy {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly store = inject(Store);
  private readonly cardDataService = inject(CardDataService);

  private readonly subs = new Subscription();

  readonly cardData = signal<any>(null);

  prepolicyid = '';
  salesforceQuoteId = '';
  codAsesor = '';

  readonly plan = toSignal(this.store.select(selectDataByKey('Plan')), { initialValue: null });

  readonly valorAPagar = computed<number>(() => {
    const cd: any = this.cardData();
    const p: any = this.plan();
    return this.toNumber(
      cd?.totalAmount ?? cd?.priceAnual?.amount ??
      p?.priceAnual?.amount ?? p?.price?.full?.amount ?? p?.planPlus ?? p?.armaTuPlan ?? 0,
    );
  });

  ngOnInit(): void {
    const params = this.route.snapshot.queryParams;
    this.prepolicyid = params['prepolicyid'] || '';
    this.codAsesor = params['codigoAsesor'] || '';
    // Reusa el QuoteId Salesforce del queryParam o del backup en sessionStorage (sarlaft-page lo guarda ahí).
    this.salesforceQuoteId = params['quoteId'] || this.readStoredSfQuoteId();

    if (this.prepolicyid) {
      const decoded = this.safeDecode(this.prepolicyid);
      this.subs.add(
        this.cardDataService.fetchInitialData(decoded, true).subscribe({
          next: (data) => this.cardData.set(data),
          error: (err) => console.error('[PagoRechazadoP2P] Error cargando cardData:', err),
        }),
      );
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  intentarDeNuevo(): void {
    const queryParams: Record<string, string> = {};
    if (this.prepolicyid) queryParams['prepolicyid'] = this.prepolicyid;
    if (this.salesforceQuoteId) queryParams['quoteId'] = this.salesforceQuoteId;
    if (this.codAsesor) queryParams['codigoAsesor'] = this.codAsesor;

    this.router.navigate([RESUMEN_COMPRA_P2P_URL], { queryParams }).then(() => {
      setTimeout(() => window.scrollTo(0, 0), 0);
    });
  }

  private readStoredSfQuoteId(): string {
    try {
      return sessionStorage.getItem('sfQuoteId') || '';
    } catch {
      return '';
    }
  }

  private safeDecode(value: string): string {
    try {
      return decodeURIComponent(value);
    } catch {
      return value;
    }
  }

  private toNumber(v: any): number {
    if (typeof v === 'number') return v;
    if (typeof v === 'string') {
      const n = Number(v.replace(/[^\d.-]/g, ''));
      return isNaN(n) ? 0 : n;
    }
    return 0;
  }
}
